// src/components/common/board/MobileSearchBar.jsx
// 모바일 전용 검색 바
import React, { useMemo, useState } from "react";

export default function MobileSearchBar({
  q,
  onChangeQ,
  onSearch,
  searchField,
  onChangeSearchField,
  placeholder = "검색어를 입력해 주세요.",
  searchFieldOptions,
  dateFilter,
  onChangeDateFilter,
  startDate,
  endDate,
  onDateChange,
  pageSize,
  onChangePageSize,
}) {
  const [showFilters, setShowFilters] = useState(false);

  const today = useMemo(() => new Date(), []);

  const fieldOptions =
    searchFieldOptions && searchFieldOptions.length
      ? searchFieldOptions
      : [
          { value: "title", label: "제목" },
          { value: "author", label: "작성자" },
          { value: "dns", label: "DNS" },
        ];

  const calcDateRange = (months) => {
    const end = today.toISOString().slice(0, 10);
    const d = new Date();
    d.setMonth(d.getMonth() - months);
    const start = d.toISOString().slice(0, 10);
    return { start, end };
  };

  const handleDateFilterChange = (v) => {
    onChangeDateFilter(v);
    if (v === "6m") onDateChange(calcDateRange(6));
    else if (v === "3m") onDateChange(calcDateRange(3));
    else if (v === "1m") onDateChange(calcDateRange(1));
    else if (v === "all") onDateChange({ start: "", end: "" });
    onSearch();
  };

  const updateStartDate = (value) => {
    if (endDate && new Date(value) > new Date(endDate)) {
      alert("시작일은 종료일보다 이후일 수 없습니다.");
      return;
    }
    onDateChange({ start: value, end: endDate });
    onSearch();
  };

  const updateEndDate = (value) => {
    if (startDate && new Date(value) < new Date(startDate)) {
      alert("종료일은 시작일보다 이전일 수 없습니다.");
      return;
    }
    onDateChange({ start: startDate, end: value });
    onSearch();
  };

  return (
    <div className="w-full min-w-0 space-y-2">
      {/* 검색어 입력 */}
      <div className="flex items-center gap-2 min-w-0">
        <select
          className="flex-shrink-0 rounded-lg border border-gray-200 px-2 py-1.5 text-xs bg-white"
          value={searchField}
          onChange={(e) => {
            onChangeSearchField(e.target.value);
            onSearch();
          }}
        >
          {fieldOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <input
          className="flex-1 min-w-0 rounded-lg border border-gray-200 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          placeholder={placeholder}
          value={q}
          onChange={(e) => onChangeQ(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onSearch()}
        />
        <button
          onClick={onSearch}
          className="btn-search flex-shrink-0 whitespace-nowrap text-xs px-3 py-1.5"
        >
          검색
        </button>
      </div>

      {/* 필터 토글 버튼 */}
      <button
        onClick={() => setShowFilters(!showFilters)}
        className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-xs text-gray-600 flex items-center justify-center"
      >
        {showFilters ? "필터 숨기기" : "상세 필터"}
      </button>

      {/* 필터 영역 */}
      {showFilters && (
        <div className="space-y-2 p-3 bg-gray-50 border border-gray-200 rounded-lg min-w-0">
          {/* 날짜 필터 */}
          <div className="space-y-2 min-w-0">
            <label className="text-xs text-gray-700 font-medium block">작성일</label>
            <select
              className="w-full rounded-lg border border-gray-200 px-2 py-1.5 text-xs bg-white"
              value={dateFilter}
              onChange={(e) => handleDateFilterChange(e.target.value)}
            >
              <option value="all">전체</option>
              <option value="6m">6개월 이내</option>
              <option value="3m">3개월 이내</option>
              <option value="1m">1개월 이내</option>
              <option value="custom">기간 직접 선택</option>
            </select>

            {dateFilter === "custom" && (
              <div className="flex items-center gap-2 min-w-0">
                <input
                  type="date"
                  className="flex-1 min-w-0 rounded-lg border border-gray-200 px-2 py-1.5 text-xs bg-white"
                  value={startDate || ""}
                  onChange={(e) => updateStartDate(e.target.value)}
                />
                <span className="text-gray-500 text-xs flex-shrink-0">~</span>
                <input
                  type="date"
                  className="flex-1 min-w-0 rounded-lg border border-gray-200 px-2 py-1.5 text-xs bg-white"
                  value={endDate || ""}
                  onChange={(e) => updateEndDate(e.target.value)}
                />
              </div>
            )}
          </div>

          {/* 페이지 사이즈 */}
          <div className="space-y-2 min-w-0">
            <label className="text-xs text-gray-700 font-medium block">페이지당 건수</label>
            <select
              className="w-full rounded-lg border border-gray-200 px-2 py-1.5 text-xs bg-white"
              value={pageSize}
              onChange={(e) => {
                onChangePageSize(Number(e.target.value));
                onSearch();
              }}
            >
              <option value={15}>15건</option>
              <option value={30}>30건</option>
              <option value={50}>50건</option>
              <option value={100}>100건</option>
            </select>
          </div>

          {/* 초기화 버튼 */}
          <button
            onClick={() => {
              onChangeQ("");
              const defaultField = (fieldOptions && fieldOptions[0]?.value) || "title";
              onChangeSearchField(defaultField);
              onChangeDateFilter("all");
              onDateChange({ start: "", end: "" });
              onChangePageSize(15);
              onSearch();
            }}
            className="btn-cancel w-full text-xs py-2"
          >
            초기화
          </button>
        </div>
      )}
    </div>
  );
}

